'use client';

import {
    EntityCategoryImage,
    type ImageItem,
    Variant as ImageVariant,
} from '../EntityCategoryImage/EntityCategoryImage';
import { Link } from '@/ui-components/atoms/Link/Link';
import { Text } from '@/ui-components/atoms/Text/Text';
import styles from './exploreall.module.scss';
import { responsiveBreakpointsPx } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';

export interface ExploreAllItemProps {
    title: string;
    items: ImageItem[];
    href: string;
    backgroundColor?: string;
}
export function ExploreAll({ title, href, items, backgroundColor }: ExploreAllItemProps) {
    const imageType = (
        <EntityCategoryImage
            items={items}
            variant={ImageVariant.stack}
            isMultiple={true}
            exploreAllBackgroundColor={backgroundColor}
        />
    );
    const viewportIsSmallSized = useMediaQuery(`(min-width: ${responsiveBreakpointsPx.md}px)`);

    return (
        <>
            {(items.length >= 4 || (items.length >= 3 && !viewportIsSmallSized)) && (
                <Link className={styles.mainWrapper} href={href}>
                    <div className={styles.imageContainer}>{imageType}</div>
                    <div className={styles.textContainer}>
                        <Text tag="div" className={styles.titleStyles} variant="h6">
                            {title}
                        </Text>
                    </div>
                </Link>
            )}
        </>
    );
}
